/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BindingSource model module.
 * @module model/BindingSource
 * @version V1
 */
class BindingSource {
    /**
     * Constructs a new <code>BindingSource</code>.
     * @alias module:model/BindingSource
     */
    constructor() { 
        
        BindingSource.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BindingSource</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BindingSource} obj Optional instance to populate.
     * @return {module:model/BindingSource} The populated <code>BindingSource</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BindingSource();

            if (data.hasOwnProperty('displayName')) {
                obj['displayName'] = ApiClient.convertToType(data['displayName'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('isGreedy')) {
                obj['isGreedy'] = ApiClient.convertToType(data['isGreedy'], 'Boolean');
            }
            if (data.hasOwnProperty('isFromRequest')) {
                obj['isFromRequest'] = ApiClient.convertToType(data['isFromRequest'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BindingSource</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BindingSource</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['displayName'] && !(typeof data['displayName'] === 'string' || data['displayName'] instanceof String)) {
            throw new Error("Expected the field `displayName` to be a primitive type in the JSON string but got " + data['displayName']);
        }
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }

        return true;
    }


}



/**
 * @member {String} displayName
 */
BindingSource.prototype['displayName'] = undefined;

/**
 * @member {String} id
 */
BindingSource.prototype['id'] = undefined;

/**
 * @member {Boolean} isGreedy
 */
BindingSource.prototype['isGreedy'] = undefined;

/**
 * @member {Boolean} isFromRequest
 */
BindingSource.prototype['isFromRequest'] = undefined;






export default BindingSource;

